<template>
  <nav class="navbar navbar-expand-lg navbar-light">
    <div class="container-fluid">
      <a class="navbar-brand" href="#">{{$t("router."+routeName)}}</a>
      <button class="navbar-toggler navbar-burger"
              type="button"
              @click="toggleSidebar"
              :aria-expanded="$sidebar.showSidebar"
              aria-label="Toggle navigation">
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
        <span class="navbar-toggler-bar"></span>
      </button>
      <div class="collapse navbar-collapse">
        <ul class="navbar-nav ml-auto">
          <drop-down class="nav-item"
                     :title="(USER) ? USER.user.name : ''"
                     title-classes="nav-link">
            <a class="dropdown-item" href="#" @click="logout"><i class="ti-power-off"></i> Logout</a>
          </drop-down>
        </ul>
      </div>
    </div></nav>
</template>
<script>
  import {mapGetters} from 'vuex'

  export default {
  computed: {
    ...mapGetters([
      'USER',
      'ROLES'
    ]),
    routeName() {
      let name = this.$route.meta.title;
      // return name
      return this.capitalizeFirstLetter(name);
    }
  },
  data() {
    return {
      activeNotifications: false
    };
  },
  methods: {
    capitalizeFirstLetter(string) {
      return string.charAt(0).toUpperCase() + string.slice(1);
    },
    toggleNotificationDropDown() {
      this.activeNotifications = !this.activeNotifications;
    },
    closeDropDown() {
      this.activeNotifications = false;
    },
    toggleSidebar() {
      this.$sidebar.displaySidebar(!this.$sidebar.showSidebar);
    },
    hideSidebar() {
      this.$sidebar.displaySidebar(false);
    },
    async logout() {
      this.$swal({
        title: this.$t('swal.logout.Title'),
        text: this.$t('swal.logout.Text'),
        type: 'warning',
        showCancelButton: true,
        confirmButtonColor: '#3085d6',
        cancelButtonColor: '#d33',
        cancelButtonText: this.$t('swal.logout.CancelButtonText'),
        confirmButtonText: this.$t('swal.logout.ConfirmButtonText')
      }).then(async (result) => {
            if (result.value) {
              await this.$store.dispatch('destroyToken')
            }
          }
      )
    },
  }
};
</script>
<style>
</style>
